import React from 'react';
import { Shield, TrendingUp, Users, Award } from 'lucide-react';

export const WhyChooseUs = () => {
  const pillars = [
    {
      icon: Shield,
      title: 'Security & Compliance',
      description: 'The security, integrity and protection of patient information is our standard operating practice. HIPAA compliant with the highest standards.',
      color: 'from-teal-500 to-teal-600'
    },
    {
      icon: TrendingUp,
      title: 'Revenue Optimization',
      description: 'Our #1 goal is to get you the reimbursement you are entitled to – in a timely manner. Maximize your practice revenue.',
      color: 'from-navy-500 to-navy-600'
    },
    {
      icon: Users,
      title: 'Experienced Staff',
      description: 'Through a combination of experienced staff, domain expertise, quality processes and proven technology we help you achieve results.',
      color: 'from-teal-500 to-teal-600'
    },
    {
      icon: Award,
      title: 'Proven Results',
      description: 'We are a high quality provider of Business Process Outsourcing services, delivering faster, sustainable and cost effective results.',
      color: 'from-navy-500 to-navy-600'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 via-white to-teal-50/30">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block bg-navy-600 text-white px-5 py-2 rounded-full text-sm font-semibold mb-6">
              About Capital Billing Services
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Security, Integrity and Protection of Patient Information
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Capital Billing Services Inc is an innovative Medical Billing, Practice Management & Consulting Company dedicated to providing your practice with the latest reimbursement strategies, information and services available to the health care industry.
            </p>

            {/* Image with overlay */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
              <img
                src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800"
                alt="Healthcare professionals collaborating"
                className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/90 via-navy-900/40 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-white text-lg font-medium italic">
                  &ldquo;We work closely with our clients to address and fulfill their ever changing needs.&rdquo;
                </p>
              </div>
            </div>
          </div>

          {/* Right Content - Pillars Grid */}
          <div className="grid sm:grid-cols-2 gap-5">
            {pillars.map((pillar, index) => {
              const Icon = pillar.icon;
              return (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 group hover:-translate-y-1"
                >
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${pillar.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{pillar.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{pillar.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
